import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Divider from "@material-ui/core/Divider";
import HistoryIcon from "@material-ui/icons/History";
import BusinessIcon from "@material-ui/icons/Business";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import Addresses from "../CheckoutProcess/Confirmation/Addresses";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { connect } from "react-redux";
import Badge from "@material-ui/core/Badge";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { CircularProgress } from "@material-ui/core";

import { ReactComponent as WalletIcon } from "./assets/wallet.svg";
import { ReactComponent as PagesIcon } from "./assets/pages.svg";
import { CustomizedDialogs } from "../StaticPages";
import { ReactComponent as LoyaltyPointsIcon } from "./assets/loyaltypoints.svg";
import { ReactComponent as DeleteIcon } from "./assets/delete.svg";
import SignupInfoDrawer from "./SignupInfoDrawer";
import GoogleAuth from "./GoogleAuth";
import AppleAuth from "./AppleAuth";
import EmailAuth from "./EmailAuth";
import PhoneAuth from "./PhoneAuth";
import { Favorite } from "@material-ui/icons";
import AccountDeletionDialog from "./AccountDeletionDialog";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",

    backgroundColor: theme.palette.background.paper,
    margin: "auto",
  },
}));

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

function SimpleList({
  language,
  settings,
  cart,
  promo_items,
  user,
  pages,
  tabState,
  setTabState,
  profileLoading,
  history,
  promise,
}) {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [deleteAccountOpen, setDeleteAccountOpen] = React.useState(false);
  const [infoDrawerOpen, setInfoDrawerOpen] = React.useState(false);
  const [pageState, setPageState] = React.useState(0);
  const [pageNo, setPageNo] = React.useState(0);

  const classes = useStyles();

  const menuPages = pages.filter((page) => page.placement == 1);
  const currencyIcon = getCurrencyIcon(settings)
  return (
    <div className={classes.root}>
      <SignupInfoDrawer
        open={infoDrawerOpen}
        onClose={() => setInfoDrawerOpen(false)}
      />

      {deleteAccountOpen && (
        <AccountDeletionDialog onClose={() => setDeleteAccountOpen(false)} />
      )}

      {!!menuPages.length && (
        <CustomizedDialogs
          open={pageState}
          handleClose={() => setPageState(false)}
          title={
            language == "arabic"
              ? menuPages[pageNo].title_ar || menuPages[pageNo].title
              : menuPages[pageNo].title
          }
          content={
            language == "arabic"
              ? menuPages[pageNo].content_ar || menuPages[pageNo].content
              : menuPages[pageNo].content
          }
          windowType={menuPages[pageNo].window_type}
        />
      )}
      {drawerOpen && (
        <Addresses
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          comingFrom="profile"
        />
      )}
      <div
        style={{
          display: "flex",
          flexDirection: language === "arabic" && "row-reverse",
          alignItems: "baseline",
          justifyContent: "space-between",
        }}
        className="mx-3 mb-3"
      >
        <h2
          classname="bold"
          style={{
            fontSize: 18,
            color: "#666666",
            fontFamily: "Quicksand, Cairo",
          }}
        >
          {language == "english" ? "Menu" : "القائمة"}
        </h2>
      </div>
      <List
        disablePadding
        dense
        component="nav"
        aria-label="Nav"
        style={{ direction: language == "english" ? "ltr" : "rtl" }}
        grid
      >
        <Divider />
        <>
          <Link to="/cart">
            <ListItem button divider>
              <ListItemIcon>
                <ShoppingCartIcon />
              </ListItemIcon>
              <p className="bold my-2" style={{ color: "#666666" }}>
                {language == "english" ? "My cart" : "سلة مشترياتي"}
                {!!(cart.length || promo_items.length) && (
                  <Badge
                    badgeContent={cart.length + promo_items.length}
                    color="primary"
                    style={{
                      top: 24,
                      right: language == "english" && 28,
                      left: language == "arabic" && 28,
                      position: "absolute",
                    }}
                  />
                )}
              </p>
            </ListItem>
          </Link>

          <Link to="/">
            <ListItem button divider>
              <ListItemIcon>
                <MenuBookIcon />
              </ListItemIcon>
              <p className="bold my-2" style={{ color: "#666666" }}>
                {language == "english"
                  ? settings.custom_texts.menu
                  : settings.custom_texts.menu_ar}
              </p>
            </ListItem>
          </Link>

          <Link to="/track/previous/">
            <ListItem button divider>
              <ListItemIcon>
                <HistoryIcon />
              </ListItemIcon>
              <p className="bold my-2" style={{ color: "#666666" }}>
                {language == "english" ? "My orders" : "طلباتي"}
              </p>
            </ListItem>
          </Link>

          {user && (
            <>
              <ListItem button onClick={() => setDrawerOpen(true)} divider>
                <ListItemIcon>
                  <BusinessIcon />
                </ListItemIcon>
                <p className="bold my-2" style={{ color: "#666666" }}>
                  {language == "english"
                    ? "Delivery addresses"
                    : "عناوين التوصيل"}
                </p>
              </ListItem>

              {settings.user_favorite_product &&
                settings.user_favorite_product_staff && (
                  <Link to="/favorites">
                    <ListItem button divider>
                      <ListItemIcon>
                        <Favorite />
                      </ListItemIcon>
                      <p className="bold my-2" style={{ color: "#666666" }}>
                        {language == "english"
                          ? "Favorites"
                          : "المنتجات المفضلة"}
                      </p>
                    </ListItem>
                  </Link>
                )}

              {settings.enable_wallet_staff && settings.enable_wallet && (
                <Link to="/wallet">
                  <ListItem button divider>
                    <ListItemIcon>
                      <WalletIcon height={17} width={17} />
                    </ListItemIcon>
                    <p className="bold my-2" style={{ color: "#666666" }}>
                      {language == "english" ? "Wallet" : "المحفطة"}
                    </p>
                    <p
                      className={"my-2".concat(
                        currencyIcon
                      )}
                      style={{
                        right: language == "english" && 28,
                        left: language == "arabic" && 28,
                        color: "#666666",
                        position: "absolute",
                      }}
                    >
                      {profileLoading ? (
                        <CircularProgress
                          size={15}
                          style={{ position: "relative", top: 3 }}
                        />
                      ) : (
                        `${user?.wallet.toFixed(settings.currency_decimals)}
                ${
                  language == "english"
                    ? settings?.currency_english
                    : settings?.currency_local
                }`
                      )}
                    </p>
                  </ListItem>
                </Link>
              )}

              {settings.enable_loyalty_points_staff &&
                settings.enable_loyalty_points &&
                !settings.enable_aseer_time && (
                  <Link to="/points">
                    <ListItem button divider>
                      <ListItemIcon>
                        <LoyaltyPointsIcon height={17} width={17} />
                      </ListItemIcon>
                      <p className="bold my-2" style={{ color: "#666666" }}>
                        {language == "english"
                          ? settings.custom_texts.loyalty_points_text
                          : settings.custom_texts.loyalty_points_text_ar}
                      </p>

                      <p
                        className="my-2"
                        style={{
                          right: language == "english" && 28,
                          left: language == "arabic" && 28,
                          color: "#666666",
                          position: "absolute",
                        }}
                      >
                        {profileLoading ? (
                          <CircularProgress
                            size={15}
                            style={{ position: "relative", top: 3 }}
                          />
                        ) : (
                          user?.points
                        )}
                      </p>
                    </ListItem>
                  </Link>
                )}
              {(settings.enable_aseer_time ||
                settings.enable_loyalty_points_page) && (
                <Link to="/rewards">
                  <ListItem button divider>
                    <ListItemIcon>
                      <LoyaltyPointsIcon height={17} width={17} />
                    </ListItemIcon>
                    <p className="bold my-2" style={{ color: "#666666" }}>
                      {language == "english" ? "Rewards" : "الجوائز"}
                    </p>
                    <p
                      className="my-2"
                      style={{
                        right: language == "english" && 28,
                        left: language == "arabic" && 28,
                        color: "#666666",
                        position: "absolute",
                      }}
                    >
                      {profileLoading ? (
                        <CircularProgress
                          size={15}
                          style={{ position: "relative", top: 3 }}
                        />
                      ) : (
                        user?.points
                      )}
                    </p>
                  </ListItem>
                </Link>
              )}

              <ListItem
                button
                divider
                onClick={() => setDeleteAccountOpen(true)}
              >
                <ListItemIcon>
                  <DeleteIcon height={17} width={17} />
                </ListItemIcon>
                <p className="bold my-2" style={{ color: "red" }}>
                  {language == "english" ? "Delete account" : "حذف الحساب"}
                </p>
              </ListItem>
            </>
          )}
        </>
      </List>
      {!!menuPages.length && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: language === "arabic" && "row-reverse",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
            className="mx-3 my-3 mt-5"
          >
            <h2 classname="bold" style={{ fontSize: 18, color: "#666666" }}>
              {language == "english"
                ? settings.custom_texts.static_pages_menu_title_text
                : settings.custom_texts.static_pages_menu_title_text_ar}
            </h2>
          </div>
          <List
            disablePadding
            dense
            component="nav"
            aria-label="Nav"
            style={{ direction: language == "english" ? "ltr" : "rtl" }}
          >
            <Divider />
            {menuPages.map((page, fpk) => (
              <>
                <ListItem
                  button
                  divider
                  onClick={() => {
                    setPageState(true);
                    setPageNo(fpk);
                  }}
                >
                  <ListItemIcon>
                    <PagesIcon width={17} height={17} />
                  </ListItemIcon>
                  <p className="bold my-2" style={{ color: "#666666" }}>
                    {language == "english" ? page.title : page.title_ar}
                  </p>
                </ListItem>
              </>
            ))}
          </List>
        </>
      )}

      {settings.enable_social_auth_staff &&
        settings.enable_social_auth &&
        !user && (
          <>
            <div
              style={{
                textAlign: language === "arabic" ? "right" : "left",
              }}
              className="mx-3 my-3 mt-5"
            >
              <h2 classname="bold" style={{ fontSize: 18, color: "#666666" }}>
                {language == "english" ? "Sign in with" : "تسجيل الدخول بواسطة"}{" "}
                <span onClick={() => setInfoDrawerOpen(true)}>
                  <InfoOutlinedIcon
                    style={{
                      float: language === "arabic" ? "left" : "right",
                      marginTop: 3,
                    }}
                  />
                </span>
              </h2>
            </div>
            <List
              disablePadding
              dense
              component="nav"
              aria-label="Nav"
              style={{ direction: language == "english" ? "ltr" : "rtl" }}
            >
              <Divider />

              <EmailAuth history={history} language={language} />
              {settings.enable_phone_login && (
                <PhoneAuth history={history} language={language} />
              )}
              <AppleAuth history={history} language={language} />
              {(promise.src === "web" ||
                settings.enable_google_login_on_app) && (
                <GoogleAuth history={history} language={language} />
              )}
            </List>
          </>
        )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    cart: state.cart.cart,
    promo_items: state.cart.promo_items,
    user: state.auth.user,
    pages: state.staticPages.pages,
    settings: state.store.store.settings,
    promise: state.promise,
  };
};
export default withRouter(connect(mapStateToProps)(SimpleList));
